import { styled } from '@mui/material';

export const DebugInfoType = {
    One: 'One',
    Two: 'Two',
    Three: 'Three',
} as const;

export type DebugInfoType = ValueOf<typeof DebugInfoType>;

const COLOR_TO_DEBUG_INFO_TYPE: Record<DebugInfoType, string> = {
    [DebugInfoType.One]: 'red',
    [DebugInfoType.Two]: 'green',
    [DebugInfoType.Three]: 'blue',
};

const DebugInfo = styled('div')<{ $id: string; $type?: DebugInfoType }>(
    ({ $id, $type = DebugInfoType.One, theme }) => ({
        position: 'relative',
        '&:before': {
            display: 'block',
            content: `"${$id}"`,
            position: 'absolute',
            top: 0,
            right: 0,
            zIndex: 9999,
            border: `1px dashed ${COLOR_TO_DEBUG_INFO_TYPE[$type]}`,
            padding: theme.spacing(0, 2),
        },
    }),
);

export default DebugInfo;
